import { useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import LocaleContext from '../contexts/locale';

const all = [];
const uuidMap = {};
const slugMap = {};
const imageMap = {};
const localeMap = {};

export const useHighlightByUuid = uuid => {
	invokeQueryAndMapData();

	if (uuid in uuidMap) {
		return uuidMap[uuid];
	}

	return null;
};

export const useHighlightBySlug = slug => {
	invokeQueryAndMapData();

	if (slug in slugMap) {
		return slugMap[slug];
	}

	return null;
};

export const useHighlightImageByUuid = uuid => {
	invokeQueryAndMapData();

	if (uuid in imageMap) {
		return imageMap[uuid];
	}

	return null;
};

const invokeQueryAndMapData = () => {
	const {
		allMarkdownRemark: { edges: highlights }
	} = useStaticQuery(query);

	const { currentLocale } = useContext(LocaleContext);

	const mapItem = ({ node: { html, fields, frontmatter: data } }) => ({
		...{
			html
		},
		...data,
		...fields
	});

	if (all.length === 0) {
		for (let highlight of highlights) {
			const item = mapItem(highlight);
			const { slug, uuid, locale, images } = item;

			if (Array.isArray(images)) {
				for (let i = 0; i < images.length; i++) {
					const image = imageMap[images[i].id] || images[i];
					const gallery = {
						[uuid]: {
							[image.id]: {
								nextImage: images[i + 1],
								prevImage: images[i - 1]
							}
						}
					};

					imageMap[image.id] = {
						...image,
						...gallery
					};
				}
			}

			localeMap[locale] = localeMap[locale] || [];
			localeMap[locale].push(item);
			slugMap[slug] = item;
			uuidMap[uuid] = item;
			all.push(item);
		}
	}

	return localeMap[currentLocale] || [];
};

export default invokeQueryAndMapData;

const query = graphql`
	query useHighlights {
		allMarkdownRemark(filter: { frontmatter: { type: { eq: "highlight" } } }) {
			edges {
				node {
					html
					fields {
						slug
						title
						parent
						description
					}
					frontmatter {
						locale
						uuid
						name
						category
						youtube_id
						icons {
							icon {
								publicURL
							}
							text
						}
						images {
							id
							childImageSharp {
								fluid(maxWidth: 1200) {
									presentationWidth
									presentationHeight
									...GatsbyImageSharpFluid_withWebp
								}
							}
						}
						text
					}
				}
			}
		}
	}
`;
